import { afterNextRender, Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs';
import { AuthService } from '../../../../../core/services/api/auth/auth.service';
import { StorageService } from '../../../../../core/services/storage/storage.service';

@Component({
    selector: 'app-logout',
    standalone: false,
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss',
})
export class LogoutComponent {
    constructor(
        private matSnackBar: MatSnackBar,
        private authService: AuthService,
        private storageService: StorageService,
    ) {
        afterNextRender(() => {
            this.authService.logout().subscribe();
            this.storageService.clearLoginUser();
            this.matSnackBar
                .open('You have successfully logged out. Redirecting...', '', {
                    duration: 2000,
                    verticalPosition: 'top',
                })
                .afterDismissed()
                .pipe(
                    finalize(() => {
                        this.gotoPage();
                    }),
                )
                .subscribe();
        });
    }

    private gotoPage(): void {
        // Reason: we need to hard refresh the page after logout to clear everything.
        window.location.href = `/landing`;
    }
}
